/**
 * Convert raw snapshot nodes (`workflow_snapshots` / `workflow_draft_snapshots`
 * → `snapshotJson.nodes`) into the canvas `WorkflowNode` shape. API-persisted
 * snapshots store `{ nodeType, configJson }`; older client-serialized ones
 * store `{ type, data }` — accept both, mirroring the tolerant read in the
 * API's workflow-snapshots routes.
 */
import type { WorkflowNode } from '../../../../types/workflow';

export function snapshotToWorkflowNodes(rawNodes: unknown[]): WorkflowNode[] {
  return rawNodes.flatMap((raw): WorkflowNode[] => {
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return [];
    const node = raw as Record<string, unknown>;
    if (typeof node.id !== 'string') return [];
    const type =
      typeof node.nodeType === 'string'
        ? node.nodeType
        : typeof node.type === 'string'
          ? node.type
          : undefined;
    const dataSource = node.configJson ?? node.data;
    const data =
      typeof dataSource === 'object' && dataSource !== null && !Array.isArray(dataSource)
        ? { ...(dataSource as Record<string, unknown>) }
        : {};
    return [{ id: node.id, type, data }];
  });
}
